import { useState, useEffect } from 'react';
import { getLoansHistory } from 'api';
import { type ILoanHistory } from 'interfaces';

export const useFetchLoans = (skipCall = false) => {
  const [isLoading, setIsLoading] = useState(!skipCall);
  const [loans, setLoans] = useState<ILoanHistory[]>([]);

  useEffect(() => {
    if (skipCall) {
      return;
    }

    let stillMounted = true;

    const getData = async () => {
      try {
        const { data } = await getLoansHistory();
        setLoans(data.data);
        setIsLoading(false);
      } catch (error) {
        setLoans([]);
        setIsLoading(false);
        throw error;
      }
    };

    if (stillMounted) {
      getData();
    }

    return () => {
      stillMounted = false;
    };
  }, [skipCall]);

  return { isLoading, loans };
};
